import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";

import image1 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-1_green_front_1200.jpg";
import image2 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-1_green_back_1200.jpg";

import image3 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-4_green_front_1200.jpg";
import image4 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-4_green_back_1200.jpg";

import image7 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-20_green_front_1200.jpg";
import image8 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-20_green_back_1200.jpg";

import image9 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-60_green_front_1200.jpg";
import image10 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-60_green_back_1200.jpg";

import image11 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-DR_green_front_1200.jpg";
import image12 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-DR_green_back_1200.jpg";

import image13 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-IBC_white_front_1200.jpg";
import image14 from "../../../images/Engine-car/synthetic/6711/pictures_FF6711-IBC_white_back_1200.jpg";


const images = [
  { src: image1, alt: "Front" },
  { src: image3, alt: "Back" },
  { src: image7, alt: "Front 4L" },
  { src: image9, alt: "Back 4L" },
  { src: image11, alt: "Back 4L" },
  { src: image13, alt: "Back 4L" }
  
];

const packageSlides = [
  { images: [image1, image2] },
  { images: [image3, image4] },
 
  { images: [image7, image8] },
  { images: [image9, image10] },
  { images: [image11, image12] },
  { images: [image13, image14] },
];



const TDS_URL = "https://www.fanfaro.de/create-pdf/10";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6711_-_FANFARO 6711 ESX 0W-40_(SK).pdf" }
];


export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
    <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/0jk89Clh" 
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}

      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO ESX 0W-40 6711</h2>

        <p>
         Universal bi-synthetic (PAO + esters) premium motor oil designed for new generations of all types of engines. Designed in accordance with the requirements of German automakers.
        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
         
          <li>A unique bi-synthetic (PAO + esters) base with an expanded range of viscous and temperature properties ensures effective engine operation in all operating modes: during cold start, in city mode, in highway mode, as well as at increased load (when driving on the road, uphill, with a trailer, maximum load) and at high ambient temperatures.</li>
          <li>Due to its excellent washing-dispersing properties and the highest thermal-oxidative stability, it effectively fights against all types of deposits and keeps engine parts and turbochargers clean throughout the entire interval between replacements.</li>
          <li>Low viscosity bi-synthetic base (PAO + esters) and a highly effective additive package provide reliable cold start in the most severe conditions, which significantly reduces engine starting wear.</li>
          <li>Due to the exceptional strength of the oil film created by the ester components, it has excellent anti-seize, anti-wear, and anti-friction properties, which helps save fuel and, combined with excellent pumpability, significantly increases engine life even in "start-stop" driving modes.</li>
          <li>It is used in engines with extended oil change intervals (Long Life up to 30,000 km) and conventional.</li>
          <li>Due to the high thermo-oxidative stability, it effectively resists aging.</li>
          <li>Has increased resistance to fuel of variable quality and effectively resists liquefaction by fuel.</li>
          <li>Designed for gasoline and diesel engines (with and without turbocharging) in a wide fleet of cars (cars, light SUVs, minibuses, and light trucks of European and other manufacturers), where the performance level of API SN / CH-4 and lower, as well as ACEA A3/B3/B4.</li>
          <li>Recommended for use in engines of Daimler, BMW, VW cars, which impose additional requirements for engine oils (according to the above specifications).</li>
          <li>The oil is not suitable for use in heavy trucks and similar vehicles!</li>

        </ul>
        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b> <ul style={{ paddingLeft: "20px" }}>
              <li>API SN/CH-4</li>
              <li>SAE 0W-40</li>
              <li>ACEA A3/B4</li>
              <li>BMW LL-04</li>
               </ul>

          </div>

          <div>
            <b>Recommendation</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>FIAT 9.55535-M2</li>
              <li>FORD WSS-M2C937-A</li>
              <li>CHRYSLER MS-10725</li>
              <li>CHRYSLER MS-12633</li>
              <li>Recommended for AMG</li>
              <li>VOLKSWAGEN 502 00</li>
              <li>VOLKSWAGEN 505 00</li>
              <li>MB 229.5</li>
              <li>MB 229.3</li>
              <li>PORSCHE A40</li>
              <li>RENAULT RN0710</li>
              <li>RENAULT RN0700</li>
              <li>GM LL-A-025</li>
              <li>GM LL-B-025</li>
              <li>RENAULT RN17</li>
            </ul>

          </div>

          <div>


            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>


              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  4L
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L
                </span>
              </li>

              

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(4);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(5);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1000L
                </span>
              </li>

            </ul>
          </div>

          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href={TDS_URL}
                  target="_blank"
                  style={{ textDecoration: "none" }}    
                >
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>
      </div>

      {/* PACKAGE MODAL */}

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {/* SDS MODAL */}



      {/* SDS MODAL */}
      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>SDS – FANFARO 6711</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>



  );
}